class MindElementContent {
    constructor(width=100,height=35){
        this.x = 0;
        this.y = 0;
        this.width = width;
        this.height = height
    }
}
export default MindElementContent